import type { Product } from '../types'

/**
 * Stok durumu (16 Eki 2026). none: stok tutulmuyor (sınırsız); out: bitti
 * (0 ya da altı); low: az kaldı eşiğinde ya da altında; ok: yeterli.
 */
export type StockState = 'none' | 'ok' | 'low' | 'out'

export function stockState(p: Pick<Product, 'stock' | 'stockMin'>): StockState {
  if (p.stock == null) return 'none'
  if (p.stock <= 0) return 'out'
  if (p.stockMin != null && p.stock <= p.stockMin) return 'low'
  return 'ok'
}

/** "12", "1,25 kg"; eksiye inmişse olduğu gibi ("-2"). */
export function formatStock(p: Pick<Product, 'stock' | 'byWeight'>): string {
  if (p.stock == null) return ''
  const n = Math.round(p.stock * 1000) / 1000
  const s = n.toLocaleString('tr-TR', { maximumFractionDigits: 3 })
  return p.byWeight ? `${s} kg` : s
}

/** Yalnız sayı, birimsiz ("12", "1,25"): kasa kartındaki küçük rozet için. */
export function formatStockNumber(p: Pick<Product, 'stock'>): string {
  if (p.stock == null) return ''
  return (Math.round(p.stock * 1000) / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 3 })
}

/** Rozetin baloncuğu: "Az kaldı: 3 adet", "24 adet kaldı", "1,25 kg kaldı". */
export function stockTip(p: Pick<Product, 'stock' | 'stockMin' | 'byWeight'>): string {
  const amount = p.byWeight ? formatStock(p) : `${formatStock(p)} adet`
  return stockState(p) === 'low' ? `Az kaldı: ${amount}` : `${amount} kaldı`
}
